module.exports = __webpack_public_path__ + "img/ios-qr-code.da117c71.png";